<template>
  <div class="page">
    <Breadcrumb routeName="RefundList" toName="售后/退款" goPathName="售后列表"></Breadcrumb>
    <a-card :bordered="false" :bodyStyle="{padding:'0px'}">
      <a-card class="install-ly" title="订单信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
        <detail-list :col="1">
          <detail-list-item term="关联订单"><span class="order-active"
                                                  @click="toDetail(orderDetails.orderNo)">{{
              orderDetails.orderNo
            }}</span>
          </detail-list-item>
          <detail-list-item term="售后商品">{{ orderDetails.orderProName }}</detail-list-item>
          <template v-if="orderDetails.orderOptionName">
            <detail-list-item v-if="orderDetails.orderProType==1" term="票型">{{ orderDetails.orderOptionName }}
            </detail-list-item>
            <detail-list-item v-else-if="orderDetails.orderProType==2" term="房型">{{ orderDetails.orderOptionName }}
            </detail-list-item>
            <detail-list-item v-else term="套餐">{{ orderDetails.orderOptionName }}</detail-list-item>
          </template>
          <detail-list-item term="数量">{{ orderDetails.orderPayNum }}</detail-list-item>
          <detail-list-item term="订单金额"><span class="price-item">￥{{ orderDetails.orderAmt }}</span>
          </detail-list-item>
          <detail-list-item term="联系人姓名">{{
              orderContactInfo ? orderContactInfo.orderContact : ''
            }}
          </detail-list-item>
          <detail-list-item term="联系人电话">{{
              orderContactInfo ? orderContactInfo.orderContactMobile : ''
            }}
          </detail-list-item>
          <detail-list-item term="联系人地址">{{
              orderContactInfo ? orderContactInfo.orderOtherContactInfo : ''
            }}
          </detail-list-item>
          <detail-list-item term="来源客户">{{
              orderDetails.orderMemberInfo ? orderDetails.orderMemberInfo : ''
            }}
          </detail-list-item>
        </detail-list>
      </a-card>
      <a-card class="install-ly" title="售后内容" :bordered="false" :headStyle="{borderBottom:'0px'}">
        <detail-list :col="3">
          <detail-list-item term="售后类型">
            <span v-if="orderDetails.afterSaleVo.afterState==0">退款</span>
            <span v-if="orderDetails.afterSaleVo.afterState==1">退货退款</span>
            <span class="label-sale">货物或服务状态：</span>{{ orderDetails.afterSaleVo.afterProStateStr }}
          </detail-list-item>
          <detail-list-item term="申请退款金额">￥{{ orderDetails.afterSaleVo.refundApplyAmt }} <span class="label-sale">退款说明：</span>{{
              orderDetails.afterSaleVo.afterRemark
            }}
          </detail-list-item>
          <detail-list-item term="用户发起售后时间">{{ orderDetails.afterSaleVo.afterCreateTime }}</detail-list-item>
        </detail-list>
        <detail-list :col="1" style="margin-bottom:30px;">
          <detail-list-item term="图片凭证">
            <div class="img-box"
                 v-if="orderDetails.afterSaleVo.afterImgList&&orderDetails.afterSaleVo.afterImgList.length>0">
              <div class="img-border" @click="previewImg(item)"
                   v-for="(item,index) in orderDetails.afterSaleVo.afterImgList" :key="index" v-show="item!=''"><img
                :src="item" alt=""></div>
            </div>
          </detail-list-item>
        </detail-list>
        <detail-list :col="1">
          <detail-list-item term="收到售后时间">
            {{ orderDetails.afterSaleVo.afterCreateTime }}
            <span class="time-line"
                  v-if="temp">等待处理  {{ countTimeData.day }}天{{ countTimeData.hour }}时{{
                countTimeData.minute
              }}分{{ countTimeData.second }}秒 未处理将自动同意</span>
          </detail-list-item>
          <detail-list-item term="拒绝原因" v-if="orderDetails.afterSaleVo&&orderDetails.afterSaleVo.denialReason">
            {{ orderDetails.afterSaleVo.denialReason }}
          </detail-list-item>

          <detail-list-item term="操作人">{{
              orderDetails.afterSaleVo && orderDetails.afterSaleVo.operationName ? orderDetails.afterSaleVo.operationName : ''
            }}
          </detail-list-item>
          <detail-list-item term="操作时间">{{
              orderDetails.afterSaleVo && orderDetails.afterSaleVo.operationTime ? orderDetails.afterSaleVo.operationTime : ''
            }}
          </detail-list-item>
        </detail-list>
        <template v-if="orderDetails.merchantAfterSaleFlag">
          <a-button type="primary" @click="handleOrderAfterSale(true)" style="margin-right:10px;">同意售后</a-button>
          <a-button type="danger" @click="handleOrder" ghost>拒绝售后</a-button>
        </template>
      </a-card>
    </a-card>
    <!-- 确认订单 -->
    <a-modal title="拒绝售后"
             :visible="confirmOrderVisible"
             @ok="handleOrderAfterSale(false)"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
    >
      <a-textarea v-model="confirmOrderRemark" placeholder="请输入备注" :maxLength="300" :rows="4"/>
    </a-modal>
    <!-- 图片预览 -->
    <PreviewImage v-if="imgDialogVisible" :dialogVisible="imgDialogVisible" :imageUrl="imageUrl" @close="closeData"
                  title="图片预览"></PreviewImage>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import PreviewImage from '@/views/platform/component/PreviewImage'

export default {
  name: 'RefundDetail',
  components: {
    Breadcrumb,
    PreviewImage
  },
  data() {
    return {
      loading: false,
      imgDialogVisible: false,
      imageUrl: '',
      orderDetails: {
        afterSaleVo: ''
      },
      afterId: this.$route.query.afterId,
      merchantId: this.$store.getters.userInfo.merchantId,
      temp: null,
      countTimeData: {
        day: '',
        hour: '',
        minute: '',
        second: ''
      },
      confirmOrderRemark: '',
      confirmOrderVisible: false,
      confirmLoading: false,
      orderContactInfo: {}
    }
  },
  activated() {
    this.afterId = this.$route.query.afterId
    this.getOrderAfterSaleDetails()
  },
  deactivated() {
    this.clearCountDown()
  },
  mounted() {

  },
  methods: {
    toDetail(orderNo) {
      // this.getLogUtils().logWithTag("record==",record);
      this.$router.push({
        name: 'OrderDetails',
        query: {
          orderNo: orderNo
        }
      })
    },
    handleCancel() {
      this.confirmOrderVisible = false
    },
    handleOrder() {
      this.confirmOrderVisible = true
    },
    handleOrderAfterSale(flag) {
      if (!flag && !this.confirmOrderRemark) {
        this.$message.error('请输入拒绝原因')
        return
      }
      let params = new Object()
      params.character = 1
      params.denialReason = this.confirmOrderRemark
      params.merchantId = this.merchantId
      params.operatorId = this.merchantId
      params.orderNo = this.orderDetails.orderNo
      params.processAfterSale = flag
      this.confirmLoading = true
      this.getHttpServices().getOrderService().post('order/AfterSale/processOrderAfterSale', params)
        .then(res => {
          this.getLogUtils().logWithTag('==handleOrderAfterSale==', res)
          this.$message.success(flag ? '同意' : '拒绝' + '售后成功')
          this.getOrderAfterSaleDetails()
          this.clearCountDown()
          this.confirmOrderVisible = false
          this.confirmOrderRemark = ''
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
    },
    // 获取订单状态
    getOrderAfterSaleDetails() {
      this.getHttpServices().getOrderService().get('order/AfterSale/getOrderAfterSaleDetails?afterId=' + this.afterId)
        .then(res => {
          this.getLogUtils().logWithTag('==getOrderAfterSaleDetails==', res)
          this.orderDetails = res
          this.orderContactInfo = res.orderContact
          if (this.orderDetails.merchantAfterSaleFlag) {
            this.setTimer()
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    setTimer() { //页面多个定时器 //主要逻辑都在这页面更新
      if (!this.temp) {
        this.temp = setInterval(() => {
          this.countDownFun(this.orderDetails.afterSaleVo.afterCreateTimestamp)
        }, 1000)
      }
    },
    clearCountDown() {
      clearInterval(this.temp)
      this.temp = null
    },
    countDownFun(time) {
      time--//时间一秒秒的减
      let nowTime = new Date().getTime() //现在时间
      if (nowTime <= time) {
        //获取时间差
        let timediff = Math.round((time - nowTime) / 1000)
        //获取还剩多少天
        let day = parseInt(timediff / 3600 / 24)
        //获取还剩多少小时
        let hour = parseInt(timediff / 3600 % 24)
        //获取还剩多少分钟
        let minute = parseInt(timediff / 60 % 60)
        //获取还剩多少秒
        let second = timediff % 60
        hour = hour < 10 ? '0' + hour : hour
        minute = minute < 10 ? '0' + minute : minute
        second = second < 10 ? '0' + second : second
        this.getLogUtils().logWithTag(`${day}天 ${hour}小时 ${minute}分钟 ${second}秒`)
        let obj = new Object()
        obj.day = day
        obj.hour = hour
        obj.minute = minute
        obj.second = second
        this.countTimeData = obj
        if (day == 0 && hour == 0 && minute == 0 && second == 0) {
          this.clearCountDown()
          this.$message.success('已自动开启售后')
          location.reload()
        }
      }
    },
    // 关闭图片预览
    closeData() {
      this.imageUrl = ''
      this.imgDialogVisible = false
    },
    // 点击图片预览
    previewImg(imgUrl) {
      this.imgDialogVisible = true
      this.imageUrl = imgUrl
    }
  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.order-active {
  color: #FAAD14;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
}

.price-item {
  font-size: 16px;
  font-weight: bold;
}

.label-sale {
  padding-left: 20px;
  color: rgba(0, 0, 0, 0.85) !important;
}

.time-line {
  color: rgba(0, 0, 0, 0.85) !important;
}

.img-box {
  position: absolute;
  height: 60px;

  .img-border {
    width: 60px;
    height: 60px;
    border: 1px dashed #e9e9e9;
    float: left;
    cursor: pointer;

    img {
      width: 58px;
      height: 58px;
      margin: auto;
    }
  }
}

</style>